var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFolder = function SvgFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFA01B",
    d: "M15.2 5.223c.73 0 1.3.574 1.3 1.25v7c0 .675-.57 1.25-1.3 1.25H2.8c-.73 0-1.3-.575-1.3-1.25V8.334h4.321c.627 0 1.238-.215 1.723-.607l3.09-2.504z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA01B",
    d: "M1 4.527c0-.964.808-1.75 1.8-1.75h3.021c.514 0 1.014.176 1.408.496L8.8 4.546 6.46 6.44c-.18.145-.405.225-.639.225H1z"
  })));
};
export default SvgFolder;